import { format } from 'date-fns';
import type { FilterDto } from './types/FilterDto';

export const START_DATE_STRING = 'startDate';
export const END_DATE_STRING = 'endDate';
export const PHARMACY_GROUP_NAME_STRING = 'pharmacyGroupName';

// Mirrors the backend's StringExtensions.ToUrl so organisation names can be
// used as the organisation segment of API routes.
export function organisationNameToUrl(name: string) {
	return name.trim().replace(/ /g, '-').toLowerCase();
}

export function getSearchParamsFilter(searchParams: URLSearchParams) {
	const startDate = searchParams.get('startDate');
	const endDate = searchParams.get('endDate');
	const pharmacyGroupName = searchParams.get('pharmacyGroupName');

	const filter: FilterDto = {
		startDate: startDate ? new Date(startDate) : null,
		endDate: endDate ? new Date(endDate) : null,
		pharmacyGroupName: pharmacyGroupName ?? null,
	};

	return filter;
}

export function getSearchParamsFromPreviousPeriod(
	searchParams: URLSearchParams,
): FilterDto {
	const currentFilter = getSearchParamsFilter(searchParams);

	if (!(currentFilter.startDate && currentFilter.endDate)) {
		return currentFilter; // Handle case where no start/end dates are provided
	}

	const previousEndDate = new Date(currentFilter.endDate);
	previousEndDate.setDate(previousEndDate.getDate() - 1);

	const previousStartDate = new Date(previousEndDate);
	previousStartDate.setDate(previousEndDate.getDate() - 30); // Adjust as needed for your "previous period" definition

	return {
		...currentFilter,
		startDate: previousStartDate,
		endDate: previousEndDate,
	};
}

export function getSearchParamsString(filter: FilterDto) {
	const searchParams = new URLSearchParams();

	if (filter.startDate != null) {
		searchParams.set('startDate', filter.startDate.toISOString());
	}

	if (filter.endDate != null) {
		searchParams.set('endDate', filter.endDate.toISOString());
	}

	if (filter.pharmacyGroupName != null) {
		searchParams.set('pharmacyGroupName', filter.pharmacyGroupName);
	}

	return searchParams;
}

export function buildFilterUrl(filter: FilterDto): string {
	const encodedStartDate = mapDateToUrl(filter.startDate);

	const encodedEndDate = mapDateToUrl(filter.endDate);

	const encodedPharmacyGroupName = encodeURIComponent(
		filter.pharmacyGroupName ?? '',
	);

	const queryString = `StartDate=${encodedStartDate}&EndDate=${encodedEndDate}&PharmacyGroupName=${encodedPharmacyGroupName}`;

	return queryString;
}

export function mapDateInWeekToUrl(date: Date | null): string {
	const urlDate = mapDateToUrl(date);

	return `dateTimeInWeek=${urlDate}`;
}

function mapDateToUrl(date: Date | null): string {
	if (date == null) {
		return 'INVALID_DATE';
	}

	return encodeURIComponent(format(date, 'yyyy-MM-dd'));
}
